/** The singular form of a screen's title.
 *
 * Five places rendered "New {title}" by stripping a trailing "s". That turned
 * Companies into "New Companie", Company Access into "New Company Acces", and
 * left Units of Measure alone. Any rule for English plurals is wrong
 * somewhere — "people", "series", "equipment" — so the spec declares its own
 * singular and this reads it.
 *
 * The fallback is the title UNCHANGED, never a guess: "New Companies" is
 * merely inelegant, while "New Companie" looks like a defect, because it is.
 */
export function singularOf(spec: { title: string; singular?: string }): string {
  return spec.singular ?? spec.title
}
